import { useOperatorFilterModel } from '@features/operator/filterByOperator';
import { usePrepaymentFilterModel } from '@features/firstPaymentDefinition/filterByPrepayments';
import { initBackboneConnectionFiltersHotels } from '@features/hotel/filterHotels';
import { watch } from 'vue';
import {
    useState, useActions,
} from 'vuex-composition-helpers';
import { IMapForFiltersSerpActions, IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';

export default function () {
    initBackboneConnectionFiltersHotels();
    const {
        setOperatorFilter,
        takenOperators,
    } = useOperatorFilterModel();
    const {
        setPrepaymentFilter,
        selectedPrepayments,
    } = usePrepaymentFilterModel();
    const {
        operators: operatorsBackbone,
        prepayments: prepaymentsBackbone,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['operators', 'prepayments']);
    const {
        action_operators: setOperatorsBackbone,
        action_prepayments: setPrepaymentsBackbone,
    } = useActions<IMapForFiltersSerpActions>(nameFilterSerpStore, ['action_operators', 'action_prepayments']);

    watch(operatorsBackbone, (value) => {
        setOperatorFilter(value);
    }, { immediate: true });

    watch(takenOperators, (value) => {
        setOperatorsBackbone(value);
    });

    watch(prepaymentsBackbone, (value) => {
        setPrepaymentFilter(value);
    }, { immediate: true });

    watch(selectedPrepayments, (value) => {
        setPrepaymentsBackbone(value);
    });
}